import useWatchTowerLive from './useWatchTowerLive';

import type { WatchTowerMockState } from './types';
import type { WatchTowerLiveActions } from './useWatchTowerLive';

export interface WatchTowerData {
  state: WatchTowerMockState,
  update: (updater: WatchTowerMockState | ((prev: WatchTowerMockState) => WatchTowerMockState)) => void,
  reset: () => WatchTowerMockState,
  isLive: true,
  isLoading: boolean,
  liveActions: WatchTowerLiveActions,
  refreshOpenCompany: () => Promise<unknown>,
}

export default function useWatchTowerMock(): WatchTowerData {
  return useWatchTowerLive();
}
